import api from '@/apis/di/dbOptionAPI';
import Crud from './crudBase';
var crud = new Crud('dbOption', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_dboption',
    field: {
      key: 'option_id',
      code: 'option_code',
      name: 'option_name'
    }
  },
  dbOptions: {}
};
const getters = {
  ...crud.getters,
  dbOptions: () => state.dbOptions
};
const actions = {
  ...crud.actions,
  /**
   * Load option
   */
  async getDbOptions(context, payload) {
    let res = null;
    payload = payload || {};
    try {
      if (!payload.reload && state.dbOptions && Object.keys(state.dbOptions).length != 0) {
        return { ...state.dbOptions };
      }
      context.commit('updateLoading', true);
      // res = await api.getDbOptions({});
      // context.commit('cacheDbOptions', res);
    } finally {
      context.commit('updateLoading', false);
    }

    return { ...res };
  },
  /**
   * Update dbOption
   */
  async updateDbOptions(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      context.commit('cacheDbOptions', { ...state.dbOptions, ...payload });
      res = await api.updateDbOptions(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }

    return res;
  },

  /**
   * Update dbOption
   */
  resetDbOptions(context, payload) {
    context.commit('cacheDbOptions', {});
  }
};
const mutations = {
  ...crud.mutations,
  cacheDbOptions(state, data) {
    state.dbOptions = data;
  }
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
